import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectedStormModeSelector, setSelectedStormMode } from '../filtersSlice';
import { SelectedStormModeStatusType } from '../utils';

export const useSelectedStormMode = () => {
  const dispatch = useDispatch();
  const stormMode = useSelector(selectedStormModeSelector);

  const onSelectStormMode = React.useCallback((selected: SelectedStormModeStatusType) => {
    dispatch(setSelectedStormMode(selected));
  }, [dispatch]);

  return {
    stormMode,
    onSelectStormMode,
  };
};
